import { GlobalDesignAction } from '../types';
import { textGrouping } from './grouping';
import TextLobbyItem from './TextLobbyItem';
import TextStyles from './TextStyles';

const textAction: GlobalDesignAction<'textStyles'> = {
  panel: TextStyles,
  lobbyItem: TextLobbyItem,
  grouping: textGrouping,
};

export default textAction;
